import { Section } from "@/components/Section";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = [
  {
    q: "Which areas do you deliver to?",
    a: "We deliver across 70+ Mumbai neighbourhoods including Andheri, Bandra, BKC, Juhu, Powai and Worli. Check the Contact page for the full coverage list.",
  },
  {
    q: "What meal timings do you offer?",
    a: "Four slots daily: Breakfast, Lunch, Snacks and Dinner. Each slot is prepared and dispatched fresh for that window.",
  },
  {
    q: "What are the order cutoff times?",
    a: "Breakfast — order by 8:00 pm the previous day. Lunch — 6:00 am same day. Snacks — 8:30 pm previous day. Dinner — 12:01 pm same day.",
  },
  {
    q: "How do you ensure freshness?",
    a: "Meals are cooked to the slot they're delivered in — never reheated batches. Farm-direct ingredients and short cook-to-delivery windows keep meals fresh.",
  },
  {
    q: "What kind of packaging do you use?",
    a: "Food-grade, hygienic packaging designed for safe, fresh, in-city delivery.",
  },
  {
    q: "Do you offer subscriptions?",
    a: "TODO — subscription options and pricing are being finalised. Please reach out via the Contact page for the latest.",
  },
];

export function FaqPreview() {
  return (
    <Section className="bg-secondary/30">
      <div className="grid gap-12 md:grid-cols-[1fr_1.5fr] md:gap-20">
        <div>
          <div className="mb-3 h-px w-10 bg-primary/40" aria-hidden />
          <span className="text-xs uppercase tracking-[0.2em] text-muted-foreground">FAQ</span>
          <h2 className="mt-3 font-display text-4xl font-medium md:text-5xl">Good questions, honest answers.</h2>
          <p className="mt-6 text-sm leading-relaxed text-muted-foreground">
            Can't find what you're looking for? Reach out via the Contact page.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full space-y-2">
          {FAQ.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="rounded-2xl border border-border bg-card px-5 transition-colors data-[state=open]:border-primary/30"
            >
              <AccordionTrigger className="py-5 text-left font-display text-lg font-medium tracking-tight hover:no-underline md:text-xl">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-muted-foreground">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </Section>
  );
}